// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUsers } from '@tabler/icons';

// type
import { NavItemType } from 'types';

// ==============================|| SUPER ADMIN MENU - USER MANAGEMENT ||============================== //

const icons = {
    IconUsers
};

const userManagement: NavItemType = {
    id: 'super-admin-user-management',
    icon: icons.IconUsers,
    type: 'group',
    children: [
        {
            id: 'super-admin-user-management-item',
            title: <FormattedMessage id="Super Admin User Management" />,
            type: 'item',
            icon: icons.IconUsers,
            url: '/super-admin/user-management',
            target: false
        }
    ]
};

export default userManagement;

